/**
 * QueueTimelineCell — the per-row timeline trigger: a small History icon that
 * opens a popover with the element's full lifecycle (fetched on open).
 * Radix popover used directly (no shared wrapper exists); z-[100] so it sits
 * above the drawer, same as the Rules action dropdown.
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC } from 'react';
import * as Popover from '@radix-ui/react-popover';
import { History } from 'lucide-react';
import type { QueueElement } from '@trafficpulse/shared';

import type { QueueProvider } from '@/features/trackers/flow-optimizer/queue-provider';
import QueueTimelineEvents from './QueueTimelineEvents';

export interface QueueTimelineCellProps {
  element: QueueElement;
  campaignId: string;
  provider: QueueProvider;
}

const QueueTimelineCell: FC<QueueTimelineCellProps> = ({
  element,
  campaignId,
  provider,
}) => (
  <Popover.Root>
    <Popover.Trigger asChild>
      <button
        type="button"
        aria-label={`Timeline for ${element.itemName}`}
        title="Full lifecycle timeline"
        className="inline-flex h-6 w-6 items-center justify-center rounded text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
      >
        <History className="h-3.5 w-3.5" aria-hidden />
      </button>
    </Popover.Trigger>
    <Popover.Portal>
      <Popover.Content
        align="end"
        sideOffset={4}
        className="z-[100] w-80 rounded-md border border-border bg-popover p-2 text-popover-foreground shadow-lg"
      >
        <p
          className="mb-1.5 truncate px-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground"
          title={element.itemName}
        >
          {element.itemName} — timeline
        </p>
        <QueueTimelineEvents
          campaignId={campaignId}
          provider={provider}
          layer={element.layer}
          bankId={element.bankId}
        />
      </Popover.Content>
    </Popover.Portal>
  </Popover.Root>
);

export default QueueTimelineCell;
